import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MeetingResponse, MinutesCollabDetails } from 'src/app/models/basicMeetingModel';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
declare var CKEDITOR: any;
import { meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues, environment_const, environment_msg } from 'src/environments/environment';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { HistoryComponent } from '../history/history.component';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { LinkNotetotaskDialogComponent } from '../link-notetotask-dialog/link-notetotask-dialog.component';
import { T } from '@angular/cdk/keycodes';
import { ProteanFormsComponent } from '../protean-forms/protean-forms.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-instant-meeting-note',
  templateUrl: './instant-meeting-note.component.html',
  styleUrls: ['./instant-meeting-note.component.css'],
  providers: [UtcDatePipe]
})
export class InstantMeetingNoteComponent implements OnInit, AfterViewInit {
  @ViewChildren('noteFocus') noteElements!: QueryList<ElementRef>;
  //UI Team variable declaration
  @Input() hideParts: any
  disaleAttachmentFileIcon: any;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  pastMeetingTourValues = pastMeetingTourValues
  //padllock variable
  matDialogRef!: MatDialogRef<AttachmentDialogComponent>;
  padlock: any;
  isPrivate: any;
  decryptKey: string = '';
  assignedToMapassignedToList: string[] = [];
  assignedToMap: any = {}; // reset first
  collabVariable = 'active'
  agendaAttachResp: any;
  attachCount: boolean = true;
  attachmentCount: any;
  responsevalue: any;
  attachmentTotalCnt: any = true;
  attachmentIcon = 'Y';
  padlockDisable: any;
  proteanHtml?: SafeHtml;
  proteanFormId: any;
  userResponse: any = [];
  @Input() pinDialogTriggered = false;
  editCollabData = <MinutesCollabDetails>{};
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  @Input() videoSectionStatusChecker: any
  disableNotesIcon: any;

  //property for adding new class for login user is a task user.
  selectedTabName: any;
  meetingInfoData: any;
  toLinkingTask: any;
  taskInfo: any;
  agendasinfoe: any;
  noteInfo: any;
  rightsList: any;
  hideSaveButton = true;
  currentUser: any
  selectedUser: any;

  //@ViewChild('noteFocus', {static: false}) noteFocus!: ElementRef;
  constructor(private utility: UtilityService, private permissionService: PermissionService, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver, public meetingService: MeetingService, private globals: Globals, private dialog: MatDialog, public commonMinService: FreeFormMinutesService, public freeFormAgenda: FreeFormAgendaService, public attachService: AttachmentService, private historyDialogService: HistoryDialogService, private notifier: NotifierService, private sanitizer: DomSanitizer) {
  }
  @Input() minAttrList: any;

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;

  showToolTip = false
  @Input() collbElementId: any;
  @Input() contentEditableBoolmin: any

  @Input() meetingResponse: any
@ViewChild('noteFocus', { static: false }) noteFocus!: ElementRef;

  ngOnInit(): void {
    this.currentUser = localStorage.getItem('userId');
    var padLockValue = this.minAttrList.isPrivate;
    if (padLockValue == 'Y') {
      this.padlock = true;
    } else {
      this.padlock = false;
    }
    // this.rightsList = this.meetingResponse.attendeeList.filter((user: any) => this.minAttrList.formDetails.editRights.includes(user.fkSecUserAttendee + ""));
this.rightsList = this.meetingResponse.attendeeList.filter((user: any) =>
  this.minAttrList?.formDetails?.editRights?.includes(user.fkSecUserAttendee + "")
);
var obj = document.getElementById("agMinId"+this.minAttrList.noteId);
    console.log("INSTANT MEET obj================",obj);
    
    this.commonMinService.activateCkeditor(obj);
  }
  ngAfterViewInit() {
    // var obj = document.getElementById("agMinId"+this.minAttrList.noteId);
    // console.log("INSTANT MEET obj================",obj);
    
    // this.commonMinService.activateCkeditor(obj);
    if (this.minAttrList?.noteId) {
    const noteElem = this.noteFocus.nativeElement;
    this.commonMinService.activateCkeditor(noteElem);
  }
    this.commonMinService.activateAllCkeditor('agChildNote');
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES, this.utility.permissionType.MODIFY);


    if (!roleFlag) {
      this.disableNotesIcon = true;
      // $("#insertAttendeeSec").attr('contenteditable', false);
      this.selectedTabName = roleFlag;
    } else {
      this.disableNotesIcon = false;

    }
    if (this.contentEditableBoolmin == false) {
      for (var i = 0; i < document.getElementsByClassName('agChildNote').length; i++) {
        document.getElementsByClassName('agChildNote')[i].setAttribute('contenteditable', 'false')
      }
    }
    //code added to allow to make private only for created user
    if (this.minAttrList.createdBy == localStorage.getItem("userId")) {
      this.padlockDisable = false;
    } else {
      this.padlockDisable = true;
    }
    //close

    if (this.minAttrList.formDetails != null && this.minAttrList.formDetails != undefined) {
      if (this.minAttrList.formDetails.editRights.includes(this.currentUser) && this.minAttrList.formDetails.formResponse != null && this.minAttrList.formDetails.formResponse != undefined) {
        const userIdToFind = localStorage.getItem('userId');
        this.userResponse = this.minAttrList.formDetails.formResponse.filter((item: any) => item.userId == userIdToFind);
        if (this.userResponse.length > 0) {
          var request = {
            formId: this.minAttrList.formDetails.formId,
            responseId: this.userResponse[0].responseId
          }
          this.selectedUser = this.userResponse[0].userId;
          this.getFormDetails(request);
        } else {
          var req = {
            formId: this.minAttrList.formDetails.formId,
          }
          this.selectedUser = this.currentUser;
          this.getFormDetails(req);
        }
      }
      else {
        if (this.minAttrList.formDetails.editRights.includes(this.currentUser)) {
          var req = {
            formId: this.minAttrList.formDetails.formId
          }
          this.selectedUser = this.currentUser + "";
          this.getFormDetails(req);
        }
        else {
          if (this.minAttrList.formDetails.formResponse != null && this.minAttrList.formDetails.formResponse != undefined) {
            var request = {
              formId: this.minAttrList.formDetails.formId,
              responseId: this.minAttrList.formDetails.formResponse[0].responseId
            }
            this.selectedUser = this.minAttrList.formDetails.formResponse[0].userId + "";
            this.getFormDetails(request);
          }
          else {
            var req = {
              formId: this.minAttrList.formDetails.formId
            }
            this.selectedUser = this.minAttrList.formDetails.editRights[0] + "";
            this.getFormDetails(req);
          }

        }
      }
    }

  }

  handleMouseUp(noteElement: HTMLDivElement): void {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      noteElement.setAttribute('highlightIndex', '0');
    }
  }
  handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
    this.sideNavService.closeAllAccordtion();
    this.sideNavService.smootherScroll(event.target);
    noteElement.setAttribute('highlightIndex', '0');
  }

  handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
    this.freeFormAgenda.trackChangesWhileEditing(
      noteElement.getAttribute('noteId')!,
      noteElement.getAttribute('agId')!,
      event,
      noteElement.getAttribute('entityType')!,
      'agMinId' + noteElement.getAttribute('noteId')
    );
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
      event.preventDefault();
      this.highlightNextText(noteElement);
    }
  }

  highlightNextText(noteElement: HTMLDivElement): void {
    // const regex = /\[XXXXXX\]/gi;
    const regex = environment_const.patternKey;
    const content = noteElement.textContent || '';
    const matches = Array.from(content.matchAll(regex));
    const count = matches.length;
    if (count === 0) return;

    let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
    noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());

    this.applyHighlight(noteElement, matches, currentIndex);
  }

  applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
    if (!noteElement.firstChild) return;

    const selection = window.getSelection();
    const range = document.createRange();

    const match = matches[highlightIndex];
    if (!match) return;
    const start = match.index!;
    const end = start + match[0].length;


    let offset = 0;
    let found = false;
    const nodes = Array.from(noteElement.childNodes);
    for (const node of nodes) {
      const nodeLength = node.textContent?.length || 0;

      if (offset + nodeLength >= start && !found) {
        const relativeStart = start - offset;
        const relativeEnd = end - offset;

        range.setStart(node, relativeStart);
        range.setEnd(node, Math.min(relativeEnd, nodeLength));

        found = true;
        break;
      }

      offset += nodeLength;
    }

    if (found) {
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }

  checkCKEditorOn(editorId: any) {

    let div = (<HTMLElement>document.getElementById("agMinId" + editorId))

    if (div != null) {

      if (!div.classList.contains('cke_editable')) {
        var caretPos = this.utility.getCaretPosition(div);

        for (var i in CKEDITOR.instances) {
          //var name = CKEDITOR.instances[i].name;
          var prom = new Promise<string>((resolve, reject) => {
            if (CKEDITOR.instances[i].name == "agMinId" + editorId) {
              CKEDITOR.instances[i].destroy(true);
              var itrl = setInterval(() => {
                if (CKEDITOR.instances["agMinId" + editorId] == undefined) {
                  clearInterval(itrl);
                  resolve("agMinId" + editorId);
                }
              }, 1000);

            }
          }).then((ckId) => {
            //let element = (<HTMLElement>document.getElementById(ckId))
            //element.contentEditable = 'true'
            var divContent = document.getElementById(ckId);
            this.commonMinService.activateCkeditor(divContent);
          }).finally(() => {

            let element = (<HTMLElement>document.getElementById("agMinId" + editorId))
            if (caretPos > 0) {
              this.utility.setCursor(caretPos, element);
            }
          });
        }

      }
    }
  }
  getMinComStatusCode() {

    if (this.meetingResponse.commonMomStatusCode == 'A') {
      this.disaleAttachmentFileIcon = true;
    } else {
      this.disaleAttachmentFileIcon = false;
    }
  }

  ngOnDestroy() {

    //  for (var instance in CKEDITOR.instances) {
    //    CKEDITOR.instances[instance].destroy();
    //  }
  }
  //attachment dialog function
  openConfidentialDialog(e: any, m: any) {

    let attchDialog = this.dialog.open(AttachmentDialogComponent, {
      data: {
        e, m, "data": this.contentEditableBoolmin,
        "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon
      },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchNotes(e._id).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'MN');
          }
        }
      });

    })
    //
  }

  bringPointerDown(id: any) {
    let elementId = "agMinId" + id;

    $('#' + elementId).each(function () {
      if ($(this).find('img').length) {
        <HTMLElement><unknown>document.getElementById(elementId)?.setAttribute("style", "display : flex; align-items : end")
      }
    });
  }

  trackChanges(id: any) {
    this.showToolTip = true;
    //
    let elementCreation = document.getElementById('agMinId' + id);
    $('#agMinId' + id).css("border", "5px solid rgba(0,0,0,.12)")
  }

  removeTrackChanges(id: any) {
    $('#agMinId' + id).css("border", "0px")
    this.showToolTip = false
  }

  // <span class="ck-user__marker ck-user__marker--2" data-name="Sebastian Harrison" data-session-id="Ex62OzZBGwPwMZ1DAPlr">&ZeroWidthSpace;<span class="ck-user__marker-line"><span class="ck-user__marker-dot"></span></span></span>


  addNewLink(entityId: any, meetingId: any) {
    let linkDialog = this.dialog.open(AddLinkDialogComponent, {
      data: { entityId, meetingId, "entityType": "MN", "attachmentMode": "LI", "data": this.contentEditableBoolmin, "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    });
    linkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchNotes(entityId).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'MN');
          }
        }
      });

    })
  }

  statusTracker(id: any, vari: any) {
    if (vari == 'active') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'false'
    }
    else if (vari == 'inActive') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'true'
    }
  }



  //padlock toggle function

  togglePadLock(e: any) {
    console.log("INSIDE PADLOCK TOGGLEs",e.target.textContent);
    
    // if ((e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    // }
    // else {
    //   this.isPrivate = "N";
    // }
    // console.log("this.isPrivate=",this.isPrivate);
    
    // this.padlock = !this.padlock;
  //   this.isPrivate = !this.isPrivate;
  // this.padlock = this.isPrivate;
   this.padlock = !this.padlock;
  this.isPrivate = this.padlock ? 'Y' : 'N';

  console.log('Padlock toggled →', this.padlock, 'isPrivate:', this.isPrivate);

  // Update the bound data model
  if (this.minAttrList) {
    this.minAttrList.isPrivate = this.isPrivate;
  }
    var data = {}
    var noteJson = {
      "isPrivate": this.isPrivate,
      "agendaId": this.minAttrList.agendaId,
      "meetingId": this.minAttrList.meetingId,
      "entityType": this.minAttrList.entityType,
      "minutesId": this.minAttrList.noteId,
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "noteId": this.minAttrList.noteId,
    }

    var saveUrl = this.freeFormAgenda.getSaveUrl("Y", this.minAttrList.entityType, noteJson);
    this.freeFormAgenda.saveMinutesAttributes(data, noteJson, saveUrl, "Y").then((result: any) => {
      Object.assign(this.minAttrList, result);
      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList?.forEach((minElem: any, minIndex: any) => {

                if ((minElem.noteId != null && minElem.noteId == this.minAttrList.noteId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });


  }

  toggleResPadLock(e: any) {
console.log("INSIDE toggleResPadLock",e.target.textContent);

    // if ((e.target.textContent).trim() == "lock_open private" || (e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    // }
    // else {
    //   this.isPrivate = "N";
    // }
    // this.padlock = !this.padlock;
    this.padlock = !this.padlock;
  this.isPrivate = this.padlock ? 'Y' : 'N';

  console.log("Toggled isPrivate:", this.isPrivate);
    var data = {}
    var noteJson = {
      "isPrivate": this.isPrivate,
      "agendaId": this.minAttrList.agendaId,
      "meetingId": this.minAttrList.meetingId,
      "entityType": this.minAttrList.entityType,
      "minutesId": this.minAttrList.noteId,
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "noteId": this.minAttrList.noteId,
    }

    var saveUrl = this.freeFormAgenda.getSaveUrl("Y", this.minAttrList.entityType, noteJson);
    this.freeFormAgenda.saveMinutesAttributes(data, noteJson, saveUrl, "Y").then((result: any) => {
      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                if ((minElem.noteId != null && minElem.noteId == this.minAttrList.noteId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });

  }

  getAttachCount(e: any) {

    this.meetingService.fetchNotes(e.noteId).subscribe((data: any) => {
      this.agendaAttachResp = data.body;

      this.attachCount = false;
    });
  }

  ngOnChanges(event: any) {

    // let noteId = event.collbElementId.currentValue
    // let htmlNoteId = 'agMinId'+noteId;
    // let jsAccessNoteId = (<HTMLElement> document.getElementById(htmlNoteId))

    // // let inputFieldCaretIndex = jsAccessNoteId.onselectstart;
    // document.addEventListener('keyup',() => {
    //   let selectionContent = window.getSelection()

    // })

  }

  createEmptyAgenda(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.AGENDA, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var newAg = 'AG'
    this.freeFormAgenda.trackAgendaEventOnClick(event, newAg);

  }

  createEmptyNote(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var entityType = "/nn";
    this.freeFormAgenda.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyTask(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.TASK, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var entityType = "/tt";
    this.freeFormAgenda.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyDecision(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var entityType = "/dd";
    this.freeFormAgenda.trackAgendaEventOnClick(event, entityType);

  }

  history(entityId: any, modifiedName: any) {
    var entityType = 'MN';
    this.historyDialogService.openHistoryDialog(entityId, entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
  }
  blur(target: any, event: any) {
    var selectTextAsNote = (event.altKey && (event.keyCode == 78 || event.keyCode == 68 || event.keyCode == 84));//(ALT+N)
    if (selectTextAsNote) {
      console.log("INSDEEEEEEEEEEEEEBLURRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR");
      
      this.commonMinService.triggerSaveMinutes(target, event);
    }
  }
  openLinkToTaskDialog(): void {
    const meetingId = this.meetingResponse?.meetingId;
    const decryptKey = this.minAttrList?.decryptKey;

    if (!meetingId || !this.minAttrList?.noteId) {
      console.error('Meeting ID or Note ID is not defined');
      return;
    }


    this.meetingResponse.agendaList.forEach((agenda: any) => {
      if (agenda.minutesList && agenda.minutesList.length > 0) {
        agenda.minutesList.forEach((minute: any) => {
          if (minute.actionItemOwner && minute.actionItemOwner.length > 0) {
            const ownerNames = minute.actionItemOwner.map((o: any) => o.ownerName);
            this.assignedToMap[minute.taskId] = ownerNames;
          }
        });
      }
    });


    // Step 1: Fetch Task by Meeting
    // Step 1: Fetch Notes first
    this.meetingService.fetchNotes(this.minAttrList.noteId).subscribe({
      next: (notes: any) => {

        const noteInfo = notes.body || [];
        this.noteInfo = noteInfo;
        // Step 2: Fetch Task
        this.meetingService.fetchTaskByMeetingId(meetingId, decryptKey).subscribe({
          next: (taskData: any[]) => {

            this.toLinkingTask = taskData;


            // Step 3: Fetch Agendas
            this.meetingService.fetchAgendaListByMeeting(meetingId).subscribe({
              next: (agendas: any[]) => {

                this.agendasinfoe = agendas || [];

                // Map notes to agendas
                const agendasWithTasks = this.agendasinfoe.map((agenda: { agendaId: any }) => ({
                  ...agenda,
                  notes: this.toLinkingTask.filter((note: { agendaId: any }) => note.agendaId === agenda.agendaId)
                }));

                // 👉 Open dialog after all three are ready
                this.dialog.open(LinkNotetotaskDialogComponent, {
                  data: {
                    meetingRes: this.toLinkingTask,
                    agendas: this.agendasinfoe,
                    agendasWithTasks,
                    noteRes: this.noteInfo,
                    type: "NOTE",
                    assignedTo: this.assignedToMap,
                    meetingTitle: this.meetingResponse.meetingTitle,
                    linkedTaskIds: Array.isArray(this.noteInfo.linkedTaskIds)
                      ? this.noteInfo.linkedTaskIds
                      : []
                  },
                  panelClass: ['animate__animated', 'animate__slideInLeft'],
                  disableClose: false,
                  position: { left: '0%' },
                  maxWidth: '100vw',
                  maxHeight: '100vh',
                  width: '50%',
                  height: '100vh',
                  autoFocus: false
                });
              },
              error: (err: any) => console.error('Error fetching agendas:', err)
            });
          },
          error: (err: any) => console.error('Error fetching task:', err)
        });
      },
      error: (err: any) => console.error('Error fetching notes:', err)
    });
  }

  //     error => {
  //       console.error('Error fetching tasks:', error);
  //     }
  //   );
  // }

  saveContent(event: any) {
    const inputs = document.querySelectorAll('input[name], select[name], textarea[name]');
    const allFields = Array.from(inputs).filter((el: any) => el.name.includes('fld'));
    const formValues: any = {};
    formValues['formId'] = this.proteanFormId;
    if (this.userResponse.length > 0) {
      formValues['pkFormResponse'] = this.userResponse[0].responseId;
    }
    allFields.forEach((el: any) => {
      const fieldId = el.name;
      const fieldValue = (el as HTMLInputElement).value || '';
      formValues[fieldId] = fieldValue;
    });
    const payload = [{ formData: formValues }];
    this.meetingService.saveFormDetails(payload).subscribe((data: any) => {
      var req = {
        responseId: data.body.data.results.pkFormResponse,
        userId: localStorage.getItem('userId'),
        formData: formValues
      }
      var endPath = this.userResponse.length > 0 ? 'updateFormResponse/' : 'saveFormResponse/';
      this.meetingService.saveFormResponse(req, this.minAttrList.noteId, endPath).subscribe((response: any) => {
        this.notifier.show({
          type: 'success',
          message: "Response Updated successfully",
        });
      })

    })

    // })
  }
  getAllProteanForm() {
    var req = {
      page: 1,
      size: 10
    }
    this.meetingService.getAllProteanForm(req).subscribe((res: any) => {
      let attchDialog = this.dialog.open(ProteanFormsComponent, {
        data: { form_response: res.body, noteId: this.minAttrList.noteId, meetingRes: this.meetingResponse },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "80%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          attchDialog.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          attchDialog.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          attchDialog.updateSize('100vw', '100vh');
        }
      });
      attchDialog.afterClosed().subscribe((response: any) => {
        this.rightsList = this.meetingResponse.attendeeList.filter((user: any) => response.editRights.includes(user.fkSecUserAttendee));
        var req = {
          formId: response.data.formObj.formId,
          noteId: this.minAttrList.noteId,
          meetingId: this.minAttrList.meetingId,
          // responseType : response.resType,
          editRights: response.editRights,
          createdBy: localStorage.getItem('userId')
        }
        this.meetingService.saveOrUpdateForm(req).subscribe((data: any) => {
          this.selectedUser = this.rightsList[0];
          this.proteanFormId = response.data.formObj.formId;
          var html = response.data.htmlStr;
          const mappedHtml = this.valueRender(html);
          this.proteanHtml = this.sanitizer.bypassSecurityTrustHtml(mappedHtml);
          this.hideSaveButton = true
          if (this.selectedUser != this.currentUser) {
            this.hideSaveButton = false;
            setTimeout(() => {
              const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
              const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
              allFields.forEach((el: any) => {
                el.setAttribute('readonly', 'true');
              })
            }, 1000);
          }
        })

        // this.proteanHtml = response.data.stringHtml;
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      })
    })

  }

  valueRender(html: string): string {
    const classMapping: { [key: string]: string } = {
      'rows': 'adc-d-flex adc-mb10',
      'cols': 'adc-co adc-p4',
      'row': 'adc-row adc-mb10',
      'col': 'adc-col adc-p4',
      'form-group-left': 'adc-iptgrp-left',
      'form-group': 'adc-iptgrp-top',
      'form-control': 'form-control',
      'btn': 'adc-btn adc-btn-primary',
      'adc-radio-hr': 'adc-rdogrp-hr',
      'adc-radio-vr': 'adc-rdogrp-vr',
      'adc-checkbox-hr': 'adc-chkgrp-hr',
      'adc-checkbox-vr': 'adc-chkgrp-vr',
      'table-warning': 'adc-table-warning',
    };
    for (const [bootstrapClass, customClass] of Object.entries(classMapping)) {
      const regex = new RegExp(`\\b${bootstrapClass}\\b`, 'g');
      html = html.replace(regex, customClass);
    }
    // Dynamic Mapping for class="radX" or class="chkX" (but NOT type="checkbox" or type="radio")
    html = html.replace(/class="([^"]*\brad\d+\b[^"]*)"/g, 'class="adc-rdo"');
    html = html.replace(/class="([^"]*\bchk\d+\b[^"]*)"/g, 'class="adc-chk"');
    const iconMapping: { [key: string]: string } = {
      'zmdi-plus-circle': 'add_circle',
      'zmdi-cloud-upload': 'cloud_upload',
      'zmdi-delete': 'delete',
      'zmdi-edit': 'edit',
      'zmdi-search': 'search',
      'addicon': 'material-icons add_circle',
    };

    for (const [zmdiIcon, materialIcon] of Object.entries(iconMapping)) {
      const regex = new RegExp(`<i class="[^"]*\\bzmdi\\s+${zmdiIcon}[^"]*"></i>`, 'g');

      // if (materialIcon === 'material-icons add_circle') {
      //   html = html.replace(regex, `<i class="material-icons" style="color:#3f51b5 ; cursor: pointer;">add_circle</i>`);
      // } else {
      //   html = html.replace(regex, `<i class="material-icons" style="color:#3f51b5 ; cursor: pointer;">add_circle</i>`);
      // }

      if (materialIcon === 'add_circle') {
        html = html.replace(regex, `<i class="material-icons" style="color:#3f51b5 ; cursor: pointer;">add_circle</i>`);
      } else {
        html = html.replace(regex, `<i class="material-icons" style="cursor: pointer;">${materialIcon}</i>`);
      }
    }
    return html;
  }

  saveFormResponse(isFormComplete: number) {
    const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
    const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
    const formValues: any = {};
    formValues.formId = this.proteanFormId;
    allFields.forEach((el: any) => {
      const fieldId = el.name;
      const fieldValue = (el as HTMLInputElement).value || '';
      formValues[fieldId] = fieldValue;
    });
    const payload = [{ formData: formValues }];
  }

  getFormDetails(req: any) {
    if (req.responseId == undefined || req.responseId == null) {
      this.meetingService.getFormDetails(req).subscribe((res: any) => {
        this.proteanFormId = this.minAttrList.formDetails.formId;
        var html = res.body.data.results.htmlStr;
        const mappedHtml = this.valueRender(html);
        this.proteanHtml = this.sanitizer.bypassSecurityTrustHtml(mappedHtml);
        this.hideSaveButton = true;
        if (this.selectedUser != this.currentUser) {
          this.hideSaveButton = false;
          setTimeout(() => {
            const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
            const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
            allFields.forEach((el: any) => {
              el.setAttribute('readonly', 'true');
            })
          }, 1000);
        }
      })
    }
    else {

      this.meetingService.getFormResponseDetails(req).subscribe((res: any) => {
        this.proteanFormId = this.minAttrList.formDetails.formId;
        var html = res.body.data.results.htmlStr;
        const mappedHtml = this.valueRender(html);
        this.proteanHtml = this.sanitizer.bypassSecurityTrustHtml(mappedHtml);
        this.hideSaveButton = true;
        if (this.selectedUser != this.currentUser) {
          this.hideSaveButton = false;
          setTimeout(() => {
            const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
            const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
            allFields.forEach((el: any) => {
              el.setAttribute('readonly', 'true');
            })
          }, 1000);
        }
      })
    }
  }
  viewUserResponse(event: any) {
    var response: any;
    this.minAttrList.formDetails.formResponse.forEach((data: any) => {
      if (data.userId == event.value) {
        response = data;
      }
    })
    if (response != undefined && response != null) {
      var request = {
        formId: this.minAttrList.formDetails.formId,
        responseId: response.responseId
      }
      this.getFormDetails(request);
      return;
    }
    else {
      var req = {
        formId: this.minAttrList.formDetails.formId,
      }
      this.getFormDetails(req);
      return;
    }
  }



}
